"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M10.91 8.08 6.53 3.7C7.6 3.25 8.77 3 10 3c1.56 0 3.03.4 4.3 1.1zm10.28 13.11-4.78-4.78-5.75-5.75-7.85-7.85-1.42 1.41 7.97 7.97L5.27 17h8.9l1.13 1.13c-.88.33-1.47 1.25-1.26 2.28.15.76.78 1.39 1.54 1.54 1.03.21 1.95-.38 2.28-1.26l1.91 1.91zM6 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M17 6.27c.58-.68.97-1.27 1.65-1.27.77 0 1.35.66 1.35 1.48V7h2v-.52C22 4.56 20.52 3 18.65 3c-1.66 0-2.54 1.27-3.18 2.03l-3.5 4.11L17 14.17z"
}), 'NoStrollerSharp');